"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./BackdropComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BackdropComponent = function BackdropComponent(_ref) {
  var show = _ref.show,
      className = _ref.className;
  return show ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "backdrop ".concat(className)
  }) : null;
};

var _default = BackdropComponent;
exports["default"] = _default;